import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXWixEditor implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxWixEditorContainer";
    }
    render(){
        // console.log("wix editor");

    }
}